import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpen } from 'lucide-react';
export function ProductPresentation() {
  const chapters = [{
    num: 1,
    title: 'El Puente Invisible: Por qué tus rodillas duelen en tu estómago'
  }, {
    num: 2,
    title: 'La Botica de tu Despensa: Los 10 ingredientes con la ciencia detrás'
  }, {
    num: 3,
    title: 'El Protocolo de 7 Días: Menú completo con recetas exactas'
  }, {
    num: 4,
    title: 'Guía de Compras Inteligente: Dónde comprar y qué evitar'
  }, {
    num: 5,
    title: 'El Movimiento como Lubricante: 4 minutos antes de levantarte'
  }, {
    num: 6,
    title: 'La Fase de Mantenimiento: Los hábitos de por vida'
  }];
  return <section className="bg-white py-16 px-6 md:px-12 lg:px-24" data-id="element-170">
      <div className="max-w-6xl mx-auto" data-id="element-171">
        <FadeIn data-id="element-172">
          <div className="text-center mb-10" data-id="element-173">
            <p className="text-sage font-bold tracking-widest uppercase mb-4" data-id="element-174">
              Presentamos:
            </p>
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-text-black mb-6" data-id="element-175">
              EL FUEGO QUE NADIE VE
            </h2>
            <p className="text-xl md:text-2xl text-text-gray max-w-3xl mx-auto" data-id="element-176">
              El manual completo de 55 páginas que te enseña a apagar la
              inflamación silenciosa que destruye tus articulaciones desde
              adentro, usando solo ingredientes de tu cocina.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-177">
          <FadeIn delay={0.2} className="order-2 md:order-1" data-id="element-178">
            <div className="bg-cream rounded-2xl p-8 border border-gold-light shadow-sm" data-id="element-179">
              <h3 className="text-2xl font-serif font-bold text-dark-green mb-6 flex items-center gap-3" data-id="element-180">
                <BookOpen className="text-gold" data-id="element-181" />
                Lo que contiene:
              </h3>

              <div className="space-y-4" data-id="element-182">
                {chapters.map(chapter => <div key={chapter.num} className="flex gap-4 items-start bg-white p-4 rounded-lg shadow-sm" data-id="element-183">
                    <span className="bg-sage text-white font-bold w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-184">
                      {chapter.num}
                    </span>
                    <p className="text-lg text-text-black font-medium pt-1" data-id="element-185">
                      {chapter.title}
                    </p>
                  </div>)}
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} className="order-1 md:order-2 flex justify-center" data-id="element-186">
            {/* CSS-only Ebook Mockup */}
            <div className="relative w-64 h-80 md:w-80 md:h-[400px]" data-id="element-187">
              <img src="https://cdn.magicpatterns.com/uploads/mrfHwz2gX4ZJDnpE5c4VNS/mokou_El_Fuego_que_Nadie_Ve_1.png" alt="Portada del ebook El Fuego Que Nadie Ve en tablet rodeada de ingredientes naturales" className="w-full h-full object-cover rounded-xl shadow-2xl transform transition-transform hover:scale-105 duration-500" data-id="element-188" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}